type GetRenderableRowsArgs = {
  meta: APIMeta[]
  metaRows: APIMeta[]
  tableID: string
  tableOptions: string[]
}

const getCells = ({
  meta,
  metaRows,
  tableID,
  tableOptions
}: GetRenderableRowsArgs) => {
  const savedTableCells = meta.filter(
    m => m.key === tableID && tableOptions.includes(m.row_key)
  )

  const newTableCells = metaRows.filter(
    m =>
      m.key === tableID &&
      tableOptions.includes(m.row_key) &&
      !savedTableCells.some(
        saved => saved.row_key === m.row_key && saved.row === m.row
      )
  )

  const tableCells = [...savedTableCells, ...newTableCells]

  return tableCells
}

const getTableRows = (tableCells: APIMeta[]) => {
  const tableRows = tableCells.reduce((accumulated, current) => {
    if (accumulated[current.row]) {
      accumulated[current.row].push(current)
    } else {
      accumulated[current.row] = [{ ...current }]
    }
    return accumulated
  }, {} as Record<number, APIMeta[]>)
  return tableRows
}

const getOrderedTableRows = (
  tableRows: Record<number, APIMeta[]>,
  { tableID, tableOptions }: GetRenderableRowsArgs
) => {
  const orderedTableRows = Object.keys(tableRows).reduce((orderedRows, row) => {
    const cells: APIMeta[] = tableRows[row]
    let newCells: APIMeta[] = []

    if (cells.length !== tableOptions.length) {
      const currentRows = cells.map(c => c.row_key)
      const missingRows = tableOptions.filter(o => !currentRows.includes(o))
      const missingFormattedRows = missingRows.map(
        current =>
          ({
            row: Number(row),
            row_key: current,
            key: tableID,
            value: ''
          } as APIMeta)
      )

      newCells = [...cells, ...missingFormattedRows]
    } else {
      newCells = [...cells]
    }

    const orderedCells = tableOptions.map(value =>
      newCells.find(x => x.row_key === value)
    )

    orderedRows[row] = orderedCells
    return orderedRows
  }, {} as Record<number, APIMeta[]>)

  return orderedTableRows
}

export const getRenderableRows = (arg: GetRenderableRowsArgs) => {
  if (arg.meta.length === 0 && arg.metaRows.length === 0) return []

  const tableCells = getCells(arg)

  const tableRows = getTableRows(tableCells)

  const orderedTableRows = getOrderedTableRows(tableRows, arg)

  return Object.values(orderedTableRows).filter(Boolean)
}
